// extracted by mini-css-extract-plugin
export default {"active":"NavButton_active__GJjzl"};